import {useState} from "react";
import {useAuth} from "../store/AuthProvider";
import axios from 'axios';

const useFetch = () => {
    const [response, setResponse] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const auth = useAuth();

    const makeRequest = (url, method, data, files = null) => {
        setIsFetching(true);
        setResponse(null);

        const formData = new FormData();

        formData.append('data', JSON.stringify({
            requestData: data,
            token: (auth && auth.token) ? auth.token : ''
        }))

        if (files){
            for(const [key, value] of Object.entries(files)){
                formData.append(key, value, value.name);
            }
        }

        axios({
            url,
            data: formData,
            method: method
        })
            .then((res) => {
                setIsFetching(false);
                setResponse({...res.data});
            })
            .catch((err) => {
                setIsFetching(false);
                setResponse({
                    state: 'error',
                    error: err
                });
            })
    }

    return {response, isFetching, makeRequest};
}

export default useFetch;